import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { deleteFocusGroup } from '../api/focusGroup.api';

export const useDeleteFocusGroup = () => {
  const queryClient = useQueryClient();
  const workspaceId = useCurrentWorkspaceId();

  return useMutation({
    mutationFn: deleteFocusGroup,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['focusGroups', workspaceId] });
    },
  });
};
